// extracted by mini-css-extract-plugin
module.exports = {"overrides":"hubspot-form_overrides__GsTs7"};